<template>
    <Card :title="$t('pages.OrderStatusSmsTemplates')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3" v-for="smsTemplate in smsTemplates" :key="smsTemplate.uuid">
                    <InputGroup>
                        <AppCheckbox
                            :model-value="selectedSmsTemplates.includes(smsTemplate.uuid)"
                            @update:model-value="() => selectSmsTemplate(smsTemplate.uuid)"
                        />
                        <template #append>
                            {{ smsTemplate.name }}
                        </template>
                    </InputGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="updateSmsTemplates">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.edit') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";
import AppCheckbox from "../../../../../components/new/form/checkbox/AppCheckbox.vue";
import InputGroup from "../../../../../components/new/form/InputGroup.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "OrderStatusSmsTemplatesCard",
    components: {
        Card, AppButton, AppCheckbox, InputGroup
    },
    data() {
        return {
            smsTemplates: [],
            selectedSmsTemplates: []
        }
    },
    methods: {
        fetchSmsTemplates() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/sms-templates`, {
                limit: 100,
            })
            .then((response) => {
                this.smsTemplates = response.data.data
            })
        },
        fetchSelectedSmsTemplates() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/statuses/${this.$route.params.orderStatusUuid}/sms-templates`)
            .then((response) => {
                this.selectedSmsTemplates = response.data.data.map((smsTemplate) => smsTemplate.sms_template_uuid)
            })
        },
        selectSmsTemplate(smsTemplateUuid) {
            if (this.selectedSmsTemplates.includes(smsTemplateUuid)) {
                this.selectedSmsTemplates = this.selectedSmsTemplates.filter((uuid) => uuid !== smsTemplateUuid)
            } else {
                this.selectedSmsTemplates.push(smsTemplateUuid)
            }
        },
        updateSmsTemplates() {
            httpClient.put(`/projects/${this.$route.params.projectUuid}/crm/statuses/${this.$route.params.orderStatusUuid}/sms-templates`, {
                sms_template_uuids: this.selectedSmsTemplates
            })
            .then(() => {
                new MessageNotificator().success(this.$t('alerts.success'))   
            })
        }
    },
    mounted() {
        this.fetchSmsTemplates()
        this.fetchSelectedSmsTemplates()
    }
}
</script>